import React, { useState, type ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";
import { useAskPassword } from "@iziping/common";
import { useNotification } from "../Notification/useNotification";
import InputIcon from "../InputIcon/InputIcon";
import styles from "./Auth.module.css";

interface Props {
  logo?: string;
  title?: string;
  subtitle?: string;
  cardStyle?: React.CSSProperties;
}

export const AskPasswordPage = ({
  logo,
  title,
  subtitle,
  cardStyle,
}: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const [email, setEmail] = useState("");
  const askPassword = useAskPassword();

  const handleSubmit = async () => {
    try {
      await askPassword.mutateAsync({ data: { email } });
      notify(t("login.askPassword.email.success"), "success");
      navigate("/login");
    } catch {
      notify(t("login.askPassword.email.error"), "error");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card} style={cardStyle}>
        {title ? (
          <div className={styles.titleBlock}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        ) : (
          logo && (
            <div className={styles.logoContainer}>
              <img src={logo} alt="Logo" className={styles.logo} />
            </div>
          )
        )}
        <InputIcon
          icon={Mail}
          placeholder={t("login.askPassword.email.placeholder")}
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value)
          }
        />
        <button className={styles.button} onClick={handleSubmit}>
          {t("login.askPassword.button")}
        </button>
      </div>
    </div>
  );
};
